import {
  loadAllImages
} from './imageLoader';

import {
  recolorCanvas,
  colorizeAlphaCanvas,
  hexToRgb
} from './colors';

const blankImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=';

async function render(
  baseCanvas: HTMLCanvasElement,
  middleCanvas: HTMLCanvasElement,
  bottomCanvas: HTMLCanvasElement,
  finalCanvas: HTMLCanvasElement,
  config: BoatConfig,
  selectedConfig: SelectedConfig,
  rendererConfig: RendererConfig,
  skipBase?: boolean,
  widthOverride?: number,
  heightOverride?: number,
  renderingMode?: 'default'|'alternate',
) : Promise<string> {
  console.log('rendering start')
  let topColorObject = config.top_colors.find((item) => item.slug === selectedConfig.top_color);
  const imageUrls = [
    rendererConfig.base,
    rendererConfig.middle_pattern,
    rendererConfig.bottom_pattern,
    rendererConfig.texture_1,
    rendererConfig.texture_2,
  ];

  if (topColorObject?.image_pattern) {
    imageUrls.push(rendererConfig.top_color_image);
  }

  const images = await loadAllImages(imageUrls);

  const baseImage = images[0];
  const middlePatternImage = images[1];
  const bottomPatternImage = images[2];
  const texture1Image = images[3];
  const texture2Image = images[4];

  let width = widthOverride ? widthOverride : baseImage.width;
  let height = heightOverride ? heightOverride : baseImage.height;

  baseCanvas.width = width;
  baseCanvas.height = height;
  middleCanvas.width = width;
  middleCanvas.height = height;
  bottomCanvas.width = width;
  bottomCanvas.height = height;
  finalCanvas.width = width;
  finalCanvas.height = height;

  const baseCanvasContext = baseCanvas.getContext("2d");
  const middleCanvasContext = middleCanvas.getContext("2d");
  const bottomCanvasContext = bottomCanvas.getContext("2d");
  const finalCanvasContext = finalCanvas.getContext("2d");

  if (!baseCanvasContext) return blankImage;
  if (!middleCanvasContext) return blankImage;
  if (!bottomCanvasContext) return blankImage;
  if (!finalCanvasContext) return blankImage;

  baseCanvasContext.clearRect(0, 0, baseCanvas.width, baseCanvas.height);
  middleCanvasContext.clearRect(0, 0, middleCanvas.width, middleCanvas.height);
  bottomCanvasContext.clearRect(0, 0, bottomCanvas.width, bottomCanvas.height);
  finalCanvasContext.clearRect(0, 0, finalCanvas.width, finalCanvas.height);

  baseCanvasContext.drawImage(baseImage, 0, 0, baseCanvas.width, baseCanvas.height);
  middleCanvasContext.drawImage(middlePatternImage, 0, 0, baseCanvas.width, baseCanvas.height);
  bottomCanvasContext.drawImage(bottomPatternImage, 0, 0, baseCanvas.width, baseCanvas.height);

  console.log('top_color', hexToRgb(rendererConfig.top_color));
  if (rendererConfig.top_color) {
    finalCanvasContext.save();
    finalCanvasContext.fillStyle = rendererConfig.top_color;
    finalCanvasContext.fillRect(0, 0, baseCanvas.width, baseCanvas.height);
    finalCanvasContext.restore();
  }

  if (topColorObject?.image_pattern) {
    const topImage = images[5];
    finalCanvasContext.save();
    finalCanvasContext.globalAlpha = 0.8;
    finalCanvasContext.drawImage(topImage, 0, 0, finalCanvas.width, finalCanvas.height);
    finalCanvasContext.restore();
  }


  if (rendererConfig.texture_1) {
    finalCanvasContext.save();
    finalCanvasContext.globalAlpha = 0.6;
    if (skipBase) {
      finalCanvasContext.drawImage(texture1Image, -100, -100, texture1Image.width * 4, texture1Image.height * 4);
    }
    else {
      finalCanvasContext.drawImage(texture1Image, 0, 0, finalCanvas.width, finalCanvas.height);
    }
    finalCanvasContext.restore();
  }

  if (rendererConfig.texture_2) {
    finalCanvasContext.save();
    finalCanvasContext.globalAlpha = 0.6;
    if (skipBase) {
      finalCanvasContext.drawImage(texture2Image, -100, -100, texture2Image.width * 4, texture2Image.height * 4);
    }
    else {
      finalCanvasContext.drawImage(texture2Image, 0, 0, finalCanvas.width, finalCanvas.height);
    }
    finalCanvasContext.restore();
  }
  let middleColor = rendererConfig.middle_color;
  let bottomColor = rendererConfig.bottom_color;

  if (middleColor) {
    recolorCanvas(middleCanvas, middleCanvasContext, hexToRgb(middleColor));
  }
  else {
    recolorCanvas(middleCanvas, middleCanvasContext, hexToRgb(bottomColor));
  }

  if (bottomColor) {
    recolorCanvas(bottomCanvas, bottomCanvasContext, hexToRgb(bottomColor));
  }

  if (renderingMode === 'alternate') {
      if (bottomColor) {
        finalCanvasContext.drawImage(bottomCanvas, 0, 0);
      }

      if (middleColor) {
        finalCanvasContext.drawImage(middleCanvas, 0, 0);
      }

      if (!skipBase) {
        finalCanvasContext.drawImage(baseCanvas, 0, 0);
      }
  }
  else {
    if (middleColor) {
      finalCanvasContext.drawImage(middleCanvas, 0, 0);
    }

    if (bottomColor) {
      finalCanvasContext.drawImage(bottomCanvas, 0, 0);
    }

    if (!skipBase) {
      finalCanvasContext.drawImage(baseCanvas, 0, 0);
    }
  }

  return finalCanvas.toDataURL("image/jpeg");
}

export {
  render
}